import React, {Component} from 'react';
//import { withNavigation } from 'react-navigation'; // 画面遷移時に再描画するために必要 1/4

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iSeatList extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stss = {
    sld_im10ss: {},
  };

  $ilp_loads = () => [
    ip.$ip_load_im10({
      mode: 'items',
      state: 'sld_im10ss',
 //     cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
//      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      cnd: bf.b([
        {
          b_when: global.c?.state.sgcd_pageCmns?.userc410 == '80',
          o_then: () => bf.q('[im10b11k]="{}"'.f(
            global.c?.state.sgcd_pageCmns?.cm20_key
          )),
        },
        {
          o_else: () => bf.q('[im10b11k]="{}" AND IFNULL([im10cz10],"10")<>"0"'.f(
            global.c?.state.sgcd_pageCmns?.cm20_key
          )),
        },
      ]),
    }),
  ];


  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iSeatDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: iv._get_hdrPfx('バインダ一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['バインダ一覧CSV'],
            ],
          }
        }}
        n_bdyW={ic.gn_w}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
//              state: 'sld_im10ss',
              state: 'sld_im10ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iSeatDtl',
              nextMode: 'show',
              keyName: 'im10_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
}

export default iSeatList;
